import React from 'react';
import { Typography, Chip, Card, CardHeader, CardContent } from '@mui/material';
import { Chat } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import TypedValue from './../TypedValue';
import RenderPeriodDateRange from '../account/reportingPeriod/RenderPeriodDateRange';

const SubjectData = ({ data, colour, text, showPeriodLabel, selectedPeriods }) => {
    const theme = useTheme();

    if (!data) {
        return (
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    {showPeriodLabel ? text : (
                        <RenderPeriodDateRange
                            period={selectedPeriods ? selectedPeriods[0] : null}
                        />
                    )}
                </Typography>
                <Typography variant="body2" sx={{ lineHeight: 1, my: 1 }}>
                    Insufficient Data
                </Typography>
            </Grid>
        );
    }

    return (
        <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                {showPeriodLabel ? text : (
                    <RenderPeriodDateRange
                        period={selectedPeriods ? selectedPeriods[0] : null}
                    />
                )}
            </Typography>
            <Chip label={`${TypedValue({ value: data.openRate, type: 'rate' })} Open Rate`} size="small" sx={{ ml: 1 }} />
            <Typography variant="h5" sx={{ color: colour }}>
                {`${data.subjectWordCount} word${data.subjectWordCount === 1 ? '' : 's'}`}
            </Typography>
            <Typography variant="body2" sx={{ color: colour, lineHeight: 1, mb: 1 }}>
                {`${data.subjectLength} character${data.subjectLength === 1 ? '' : 's'}`}
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    fontStyle: 'italic',
                    color: theme.palette.text.primary
                }}>
                '{data.subject}'
            </Typography>
        </Grid>
    );
};

const BestSubject = ({ a, b, showB, periodColours, selectedPeriods }) => {
    return (
        <Card>
            <CardHeader
                title="Best Subject Line Length"
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                sx={{
                    m: 0,
                    px: 2,
                    py: 1
                }}
                avatar={<Chat />}
            />
            <CardContent
                sx={{
                    m: 0,
                    px: 2,
                    py: 1,
                    '&:last-child': {
                        paddingBottom: 1
                    }
                }}
            >
                <Grid container spacing={2}>
                    <SubjectData
                        colour={periodColours[0]}
                        data={a}
                        text="Period A:"
                        showPeriodLabel={showB}
                        selectedPeriods={selectedPeriods}
                    />
                    {showB && (
                        <SubjectData
                            colour={periodColours[1]}
                            data={b}
                            text="Period B:"
                            showPeriodLabel={true}
                            selectedPeriods={selectedPeriods}
                        />
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default BestSubject;